import { TextField } from "@mui/material";
import { grid } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import axios from "axios";
import id from "date-fns/esm/locale/id/index.js";
import fileDownload from "js-file-download";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import Heading from "../../../Components/Heading/Heading";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  getMilestoneDataUrl,
  MilestoneExportToExcel,
  getMilestoneFilterData,
  mileStoneCarryForward,
  CheckIfMilestoneExists,
  getCapacityUtilizationCustomerData,
  getEngagementsdd,
} from "../../../Helpers/API/APIEndPoints";
import { LoaderContext } from "../../../Helpers/Context/Context";
import notify from "../../../Helpers/ToastNotification";
import "./MilestoneMaster.css";
import { Box } from "@mui/material";
// import Modal from "@mui/material/Modal";
import { Modal } from "react-bootstrap";
import { getContext } from "../../../Helpers/Context/Context";
import { eventWrapper } from "@testing-library/user-event/dist/utils";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import {
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
  FormControl,
} from "@mui/material";
import { Tooltip } from "antd";

const MilestoneMaster = () => {
  let navigate = useNavigate();
  /*Vaishnavi milestone changes*/
  const [date, setDate] = useState<Date | null>(
    moment().startOf("month").toDate()
  );
  const [month, setMonth] = useState(
    moment().startOf("month").toDate().getMonth()
  );
  const [plannedDate, setPlannedDate] = useState<Date | null>(null);
  const [revisedDate, setrevisedDate] = useState<Date | null>(null); /****/
  const [milestoneData, setMilestoneData] = useState([]);

  const [milestoneFilterData, setMilestoneFilterData] = useState([]);
  const [milestoneCarryforwardData, setMilestoneCarryforwardData] = useState(
    []
  );
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [fromDate, setFromDate] = React.useState<Date | null>(
    moment().startOf("month").toDate()
  );
  const [toDate, setToDate] = React.useState<Date | null>(
    moment().endOf("month").toDate()
  );
  const [filterData, setFilterData] = useState(false);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [open, setOpen] = useState(false);
  const [carryforwardopen, setcarryforwardOpen] = useState(false);
  const [milestoneId, setmilestoneId] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [cryFrwdMinDate, setCryFrwdMinDate] = React.useState<any>(null);
  const [newselectedDate, setNewSelectedDate] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerSelectData, setCustomerSelectData] = useState([]);   //deepak gupta
  const [engagementOptions, setEngagementOptions] = useState([]);
  const [engagementSelectedData, setEngagementSelectedData] = useState([]);   //deepak gupta
  const [refresh, setRefresh] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isrecurred, setIsRecurred] = useState(false);
  const [iscarryforwarded, setIsCarryforward] = useState(false);
  const [isactive, setIsActive] = useState("Active");

  let formErrorObj = {};

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "customer",
      label: "Customer",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "engagement_Name",
      label: "Engagement",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "mileStones",
      label: "Milestone",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({
          //style: { display: "flex", justifyContent: "right" },
          align: "right",
        }),
      },
    },

    {
      name: "plannedDate",
      label: "Planned Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },

    {
      name: "revisedDate",
      label: "Revised Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "remark",
      label: "Remark",
      options: {
        display: false,
      },
    },

    {
      name: "completedDate",
      label: "Completed Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          if (value === null || value === "Invalid date") {
            return <p></p>;
          } else {
            return <p>{value}</p>;
          }
        },
      },
    },

    {
      name: "invoicedDate",
      label: "Invoiced Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          if (value === null || value === "Invalid date") {
            return <p></p>;
          } else {
            return <p>{value}</p>;
          }
        },
      },
    },

    {
      name: "isActive",
      label: "Active",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          let fetchedrevisedDate =
            tableMeta.tableData[tableMeta.rowIndex].revisedDate;
          let invoiceDate =
            tableMeta.tableData[tableMeta.rowIndex].invoicedDate;
          return (
            <>
              <Tooltip title="Edit" color={customColors[0]}>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("edit", { state: id });
                  }}
                  className="action_icon"
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </a>
              </Tooltip>

              {invoiceDate == "Invalid date" && (
                <Tooltip title="Carry Forward" color={customColors[0]}>
                  <a
                    onClick={() => {
                      handlecarryforwardOpen(id, fetchedrevisedDate);
                      // setCryFrwdMinDate()
                    }}
                    className="action_icon"
                  >
                    {/* <DeleteForeverIcon /> */}
                    <i
                      className="fa fa-arrow-circle-right"
                      aria-hidden="true"
                    ></i>
                  </a>
                </Tooltip>
              )}
            </>
          );
        },
      },
    },
  ];
  const context = getContext();
  const handleOpen = () => {
    setPlannedDate(null);
    setOpen(true);
    setFormErrors({});
  };
  const handlecarryforwardOpen = (id, fetchedrevisedDate) => {
    debugger;
    setmilestoneId(id);
    const newDateTime = moment(fetchedrevisedDate, "DD/MM/YYYY").toDate();
    setcarryforwardOpen(true);
    const newCarryForworddata = getMinDate(newDateTime);
    const newdateFormate = moment(newCarryForworddata, "dd/MM/YYYY").toDate();
    setCryFrwdMinDate(newdateFormate);
    setrevisedDate(null);
    setFormErrors({});
  };

  const handleClose = () => {
    setOpen(false);

    setcarryforwardOpen(false);
  };

  const ConvertArrayToString = (arr) => {
    let s = [];
    arr.map((i) => s.push(i.id));
    return s.join(",");
  };

     //deepak gupta
  // useEffect(()=>
  //   {
  //     localStorage.setItem("customerSelectData", JSON.stringify(customerSelectData));
  //     localStorage.setItem("engagementSelectedData", JSON.stringify(engagementSelectedData));
  //   },[customerSelectData, engagementSelectedData])
  
    // const clearUnwantedLocalStorage = () => {
    //   const keysToKeep = ["customerSelectData", "engagementSelectedData"];
    //   Object.keys(localStorage).forEach((key) => {
    //     if (!keysToKeep.includes(key)) {
    //       localStorage.removeItem(key);
    //     }
    //   });
    // };

  useEffect(() => {
    localStorage.clear();    //deepak gupta
    GetEngagements();
    GetCustomerData();
  }, []);

  useEffect(() => {
    (async () => {
      showLoader();

      let customers = ConvertArrayToString(customerSelectData);
      let engagementTypes = ConvertArrayToString(engagementSelectedData);
      let requestParams = {
        Customer: customers,
        Engagement_Name: engagementTypes,
        start: start,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        searchText: searchText,
        fromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
        toDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        //added by mahesh
        IsCompletedFilter: isCompleted,
        IsRecuredFilter: isrecurred,
        IsCarryFowardedFilter: iscarryforwarded,
        activeStatusFilter: isactive,
        //end
      };

      const { data } = await APICall(
        getMilestoneDataUrl,
        "POST",
        requestParams
      );

      if (
        (data != null || data != undefined) &&
        data.milestoneData.length > 0
      ) {
        setMilestoneData(data.milestoneData);
        await data.milestoneData.map(async (mileStone) => {
          mileStone.plannedDate = await moment(mileStone.plannedDate).format(
            "DD/MM/YYYY"
          );
          mileStone.revisedDate = await moment(mileStone.revisedDate).format(
            "DD/MM/YYYY"
          );
          mileStone.completedDate = await moment(
            mileStone.completedDate
          ).format("DD/MM/YYYY");
          mileStone.invoicedDate = await moment(mileStone.invoicedDate).format(
            "DD/MM/YYYY"
          );
        });
        setCount(data.milestoneData[0].count);
      } else {
        setMilestoneData([]);
        setCount(0);
      }
      hideLoader();
    })();
  }, [
    start,
    sortColumn,
    sortDirection,
    searchText,
    filterData,
    refresh,
    isactive,
  ]);

  const handleChange = (event: SelectChangeEvent) => {
    setIsActive(event.target.value);
  };

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },

    //added by mahesh
    customToolbar: () => {
      return (
        <FormControl sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="Active"
            value={isactive}
            onChange={handleChange}
            sx={{
              width: 80,
              height: 30, // Set the desired height
              "&:focus": { color: "success.main" }, // Change text color to green on focus
            }}
          >
            <MenuItem value={"Active"}>Yes</MenuItem>
            <MenuItem value={"All"}> All</MenuItem>
            <MenuItem value={"Inactive"}>No</MenuItem>
          </Select>
        </FormControl>
      );
    },
  };

  /*Vaishnavi*/
  const getFilterRecurringData = async () => {
    showLoader();
    //let EmployeeId = context.EmployeeId;
    await onSubmitValidation("populateRecurringData");

    let isEmpty = Object.values(formErrorObj).every(
      (f) => f === "" || f === null || f === undefined
    );
    let requestParams = {
      pdate: moment(plannedDate).format(moment.HTML5_FMT.DATE),
      CreatedBy: context.EmployeeId,
    };
    if (isEmpty === true) {
      const { data } = await APICall(
        getMilestoneFilterData,
        "POST",
        requestParams
      );
      if (data == 0) {
        notify(1, " MileStone Already Exists");
      } else {
        notify(0, data + " Milestone value saved");
        if (data) {
          setRefresh(true);
        }
      }
      setOpen(false);
      if (data.milestoneFilterData != null) {
        setMilestoneFilterData(data.milestoneFilterData);
        await data.milestoneFilterData.map(async (mileStone) => {
          mileStone.plannedDate = await moment(mileStone.plannedDate).format(
            "DD/MM/YYYY"
          );
          mileStone.revisedDate = await moment(mileStone.revisedDate).format(
            "DD/MM/YYYY"
          );
          mileStone.completedDate = await moment(
            mileStone.completedDate
          ).format("DD/MM/YYYY");
          mileStone.invoicedDate = await moment(mileStone.invoicedDate).format(
            "DD/MM/YYYY"
          );
        });
      }
    }

    hideLoader();
  };

  const mileStoneCarryForwardData = async () => {
    showLoader();
    await onSubmitValidation("carryForward");
    let isEmpty = Object.values(formErrorObj).every(
      (f) => f === "" || f === null || f === undefined
    );
    //let EmployeeId = context.EmployeeId;
    let requestParams = {
      rdate: moment(revisedDate).format(moment.HTML5_FMT.DATE),
      CreatedBy: context.EmployeeId,
      Id: milestoneId,
    };
    if (isEmpty == true) {
      const { data } = await APICall(
        mileStoneCarryForward,
        "POST",
        requestParams
      );

      if (data == 0) {
        notify(1, " Milestone Already Exists");
      } else {
        notify(0, " Milestone value saved");
      }

      setcarryforwardOpen(false);

      if (data.milestoneCarryforwardData != null) {
        setMilestoneCarryforwardData(data.milestoneCarryforwardData);
        await data.milestoneCarryforwardData.map(async (mileStone) => {
          mileStone.plannedDate = await moment(mileStone.plannedDate).format(
            "DD/MM/YYYY"
          );
          mileStone.revisedDate = await moment(mileStone.revisedDate).format(
            "DD/MM/YYYY"
          );
          mileStone.completedDate = await moment(
            mileStone.completedDate
          ).format("DD/MM/YYYY");
          mileStone.invoicedDate = await moment(mileStone.invoicedDate).format(
            "DD/MM/YYYY"
          );
        });
      }
    }

    hideLoader();
  };

  //sangam
  const GetCustomerData = async () => {
    let { data } = await APICall(
      getCapacityUtilizationCustomerData,
      "POST",
      {}
    );

    let options = [];

    data.map((item, index) => {
      options.push({ value: item.name, label: item.name, id: item.id });
    });

    options.sort((a, b) => a.value.localeCompare(b.value));

    setCustomerOptions(options);
  };

  const GetEngagements = async () => {
    let { data } = await APICall(getEngagementsdd, "POST", {});

    let options = [];

    data.map((item, index) => {
      options.push({
        value: item.engagement,
        label: item.engagement,
        id: item.id,
      });
    });

    options.sort((a, b) => a.value.localeCompare(b.value));

    setEngagementOptions(options);
  };

  const onSubmitValidation = async (e) => {
    await setFormErrors({});
    if (e === "populateRecurringData") {
      if (plannedDate === undefined || plannedDate === null) {
        setFormErrors((preState) => ({
          ...preState,
          ["plannedDate_isEmpty"]: "Planned Date cannot be empty",
        }));
        formErrorObj["plannedDate_isEmpty"] = "Planned Date cannot be empty";
      }
    }
    if (e === "carryForward") {
      if (revisedDate == undefined || revisedDate == null) {
        setFormErrors((preState) => ({
          ...preState,
          ["revisedDate_isEmpty"]: "Revised Date cannot be empty",
        }));
        formErrorObj["revisedDate_isEmpty"] = "Revised Date cannot be empty";
      }
    }
  };

  /*Vaishnavi*/
  const ExportToExcel = async () => {
    let customers = ConvertArrayToString(customerSelectData);
    let engagementTypes = ConvertArrayToString(engagementSelectedData);

    axios
      .request({
        responseType: "blob",
        method: "POST",

        //data: Response,
        url: MilestoneExportToExcel,
        //data:JSON,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: {
          start: 0,
          pageSize: count,
          searchText: searchText,
          sortColumn: sortColumn,
          sortDirection: sortDirection,
          fromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          toDate: moment(toDate).format(moment.HTML5_FMT.DATE),
          Customer: customers,
          Engagement_Name: engagementTypes,
          IsCompletedFilter: isCompleted,
          IsRecuredFilter: isrecurred,
          IsCarryFowardedFilter: iscarryforwarded,
          activeStatusFilter: isactive,
        },
      })
      .then((response) => {
        fileDownload(response.data, "Milestone.xlsx");
      })
      .catch((error) => {
        notify(1, "Something went wrong!");
      });
  };

  //added mahesh
  const getMinDate = (cryFrwdMinDate) => {
    debugger;
    const currentDate = new Date(cryFrwdMinDate);
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const nextMonth = currentMonth + 1;
    const nextYear = nextMonth > 11 ? currentYear + 1 : currentYear;
    const adjustedMonth = nextMonth % 12;

    const minDate = new Date(nextYear, adjustedMonth, 1);
    const minimumDate = moment(minDate).format("dd/MM/yyyy");

    return minimumDate;
  };

  //end

  const handleFilterChange = async (event, name) => {
    if (name === "customer") {
      setCustomerSelectData(event);
    }
    if (name == "engagement") {
      setEngagementSelectedData(event);
    }

    if (name === "fromDate") {
      setFromDate(event);
    }

    if (name === "toDate") {
      setToDate(event);
    }

    if (name === "plannedDate") {
      setPlannedDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["plannedDate_isEmpty"]: "",
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["plannedDate_isEmpty"]: "Planned Date Cannot be empty",
        }));
      }
    }

    if (name === "revisedDate") {
      setrevisedDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["revisedDate_isEmpty"]: "",
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["revisedDate_isEmpty"]: "Revised Date Cannot be empty",
        }));
      }
    }

    // setYear(yyyy);
  };

  const onClickFunction = async (action) => {
    if (action === "reset") {
      setEngagementSelectedData([]);
      setCustomerSelectData([]);
      setFromDate(moment().startOf("month").toDate());
      setToDate(moment().endOf("month").toDate());
      //added by mahesh
      setIsCompleted(false);
      setIsCarryforward(false);
      setIsRecurred(false);
     
    }
    setFilterData(!filterData);

    if (action === "populateRecurringData") {
      getFilterRecurringData();
    }

    if (action == "carryForward") {
      mileStoneCarryForwardData();
    }
  };

  // const style = {
  //   position: "absolute" as "absolute",
  //   top: "50%",
  //   left: "50%",
  //   transform: "translate(-50%, -50%)",
  //   width: 360,
  //   bgcolor: "background.paper",

  //   boxShadow: 24,
  //   p: 4,
  // };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"Milestone"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div>
                <button
                  onClick={() => navigate("edit")}
                  className="btn btn-update"
                >
                  Create
                </button>
              </div>
              <div className="d-flex gap-2">
                <button onClick={() => handleOpen()} className="btn btn-submit">
                  Recurring Milestone
                </button>
                <button
                  onClick={() => ExportToExcel()}
                  className="btn btn-export"
                >
                  Export to Excel
                </button>
                <a className="filterIcon" onClick={toggleFilter}>
                  <i className="fa fa-filter"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Customer</label>
                    <SelectForm
                      options={customerOptions}
                      placeholder="Select"
                      value={customerSelectData}
                      onChange={(event) =>
                        handleFilterChange(event, "customer")
                      }
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Engagement</label>
                    <SelectForm
                      options={engagementOptions}
                      placeholder="Select"
                      value={engagementSelectedData}
                      onChange={(event) =>
                        handleFilterChange(event, "engagement")
                      }
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>From Date</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="From date"
                        value={fromDate}
                        onChange={(e) => handleFilterChange(e, "fromDate")}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>To Date</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="To date"
                        value={toDate}
                        onChange={(e) => handleFilterChange(e, "toDate")}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                {/* added by mahesh  */}
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label htmlFor="isCompleted">Completed</label>
                    <div>
                      <input
                        id="isCompleted"
                        type="checkbox"
                        onChange={(e) => setIsCompleted(e.target.checked)}
                        name="isCompleted"
                        checked={isCompleted}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label htmlFor="iscarryforwarded">Carry Forwarded</label>
                    <div>
                      <input
                        id="iscarryforwarded"
                        type="checkbox"
                        onChange={(e) => setIsCarryforward(e.target.checked)}
                        name="iscarryforwarded"
                        checked={iscarryforwarded}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label htmlFor="isrecurring">Recurring</label>
                    <div>
                      <input
                        id="isrecurring"
                        type="checkbox"
                        onChange={(e) => setIsRecurred(e.target.checked)}
                        name="isrecurring"
                        checked={isrecurred}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      onClick={() => onClickFunction("reset")}
                      className="btn btn-reset"
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => onClickFunction("Submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              data={milestoneData}
              columns={gridColumns}
            />
          </div>
        </div>
      </div>
      <Modal show={open} onHide={handleClose} backdrop="static" centered>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <label>
                  Date <sup>*</sup>
                </label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label=" Date"
                    value={plannedDate}
                    onChange={(e) => handleFilterChange(e, "plannedDate")}
                    inputFormat="dd/MM/yyyy"
                    renderInput={(params) => (
                      <TextField size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
                <p style={{ color: "red" }}>
                  {formErrors["plannedDate_isEmpty"]}
                </p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  onClick={() => handleClose()}
                  className="btn btn-reset"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-submit"
                  onClick={() => onClickFunction("populateRecurringData")}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={carryforwardopen}
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <label>
                  Date <sup>*</sup>
                </label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label=" Date"
                    value={revisedDate}
                    onChange={(e) => handleFilterChange(e, "revisedDate")}
                    inputFormat="dd/MM/yyyy"
                    renderInput={(params) => (
                      <TextField size="small" {...params} />
                    )}
                    minDate={cryFrwdMinDate}
                    // locale={enUS}
                  />
                </LocalizationProvider>
                <p style={{ color: "red" }}>
                  {formErrors["revisedDate_isEmpty"]}
                </p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  onClick={() => handleClose()}
                  className="btn btn-reset"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-submit"
                  onClick={() => onClickFunction("carryForward")}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MilestoneMaster;
